import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONFINANCE_LOAD_BY_INSTITUTION_ID,
    ACTION_INSTITUTIONFINANCE_LOAD_BY_ID,

    ACTION_INSTITUTIONFINANCE_SAVE,

    ACTION_INSTITUTIONFINANCE_CREATE,

    ACTION_INSTITUTIONFINANCE_VALIDATE,

    IInstitutionFinanceLoadByInstitutionIdAction,
    IInstitutionFinanceLoadByIdAction,
    IInstitutionFinanceLoadFailureAction,
    IInstitutionFinanceLoadSuccessAction,

    IInstitutionFinanceSaveAction,
    IInstitutionFinanceSaveSuccessAction,
    IInstitutionFinanceSaveFailureAction,

    IInstitutionFinanceCreateAction,
    IInstitutionFinanceCreateSuccessAction,
    IInstitutionFinanceCreateFailureAction,

    IInstitutionFinanceValidateAction,
    IInstitutionFinanceValidateSuccessAction,
    IInstitutionFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionFinance";
import { institutionFinanceApi } from "../services/institutionFinance";

export const
    getInstitutionFinanceByInstitutionIdEpic = (action$): Observable<IInstitutionFinanceLoadSuccessAction | IInstitutionFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONFINANCE_LOAD_BY_INSTITUTION_ID)
            .mergeMap((action: IInstitutionFinanceLoadByInstitutionIdAction) => {
                return institutionFinanceApi
                    .getInstitutionFinanceByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionFinanceByIdEpic = (action$): Observable<IInstitutionFinanceLoadSuccessAction | IInstitutionFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONFINANCE_LOAD_BY_ID)
            .mergeMap((action: IInstitutionFinanceLoadByIdAction) => {
                return institutionFinanceApi
                    .getInstitutionFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionFinanceEpic = (action$): Observable<IInstitutionFinanceSaveSuccessAction | IInstitutionFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONFINANCE_SAVE)
            .mergeMap((action: IInstitutionFinanceSaveAction) => {
                return institutionFinanceApi
                    .setInstitutionFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionFinanceEpic = (action$): Observable<IInstitutionFinanceCreateSuccessAction | IInstitutionFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONFINANCE_CREATE)
            .mergeMap((action: IInstitutionFinanceCreateAction) => {
                return institutionFinanceApi
                    .createInstitutionFinance(action.institutionId)
                    .map(response =>
                        CreateSuccess(
                            response.institutionFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionFinanceEpic = (action$): Observable<IInstitutionFinanceValidateSuccessAction | IInstitutionFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONFINANCE_VALIDATE)
            .mergeMap((action: IInstitutionFinanceValidateAction) => {
                return institutionFinanceApi
                    .validateInstitutionFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }